import { Button, Col, Row, Tabs, Typography } from 'antd'
import React, { FC, useState } from 'react'

const { Paragraph, Link, Text } = Typography
const { TabPane } = Tabs

import { DownloadOutlined } from '@ant-design/icons'
import { CodeBlock } from 'formtopia/react-admin/components/Copiable'
import QRCode from 'react-qr-code'
import { UrlLinkInput } from './UrlLinkInput'

import { useRecordContext } from 'react-admin'
import { Form } from 'shared/types'

import {
  FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, RedditIcon, RedditShareButton, TwitterIcon, TwitterShareButton
} from 'react-share'

const makeUri = (path: string) => `${document.location.origin}/${path.replace(/^\//g, '')}`

const downloadQRCode = () => {
  const svg = document.getElementById("powCloudQR")
  const svgData = new XMLSerializer().serializeToString(svg)
  const canvas = document.createElement("canvas")
  const ctx = canvas.getContext("2d")
  const img = new Image()
  img.onload = function () {
    canvas.width = img.width
    canvas.height = img.height

    ctx.drawImage(img, 0, 0, canvas.width, canvas.height, 0, 0, 800, 800)
    const pngFile = canvas.toDataURL("image/png")

    const downloadLink = document.createElement("a")
    downloadLink.download = "qrcode"
    downloadLink.href = `${pngFile}`
    downloadLink.click()
  }

  img.src = "data:image/svg+xml;base64," + btoa(svgData)
}

const useTabContent = (record: Form) =>
  React.useMemo(
    () => [
      {
        name: 'Link',
        content: (
          <>
            <UrlLinkInput formKey={record.key} urlLink={makeUri(`/forms/${record.key}`)} />
            {/* <Input.Group size="large" compact>
              <Input
                style={{
                  width: 'calc(100% - 200px)',
                  background: 'rgba(150, 150, 150, 0.1)',
                  borderTopLeftRadius: 10,
                  borderBottomLeftRadius: 10,
                  fontWeight: 'bold'
                }}
                readOnly={true}
                defaultValue={`${makeUri(`/forms/${record.key}`)}`}
              />
              <Tooltip title="Open URL in new window">
                <Button
                  size="large"
                  type="primary"
                  style={{ borderRadius: 0 }}

                  onClick={() => { window.open(`${makeUri(`/forms/${record.key}`)}`) }}
                  icon={<OpenInNewOutlinedIcon style={{ fontSize: 15 }} />}
                >
                  Open
                </Button>
              </Tooltip>
              <Tooltip title="Copy Form URL">
                <Button
                  size="large"
                  type="primary"
                  style={{ borderTopRightRadius: 10, borderBottomRightRadius: 10, borderLeft: '1px solid #0d6ba5' }}
                  onClick={() => { navigator.clipboard.writeText(`${makeUri(`/forms/${record.key}`)}`) }}
                  icon={<CopyOutlined />}>
                  Copy
                </Button>
              </Tooltip>
            </Input.Group> */}

            <br />
            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'space-evenly' }}>
              <div style={{ marginTop: 20 }}>
                <Text strong>Share Your Form Page</Text>
              </div>
              <div style={{ marginTop: 20 }}>
                <Text strong>Social Sharing</Text>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'space-evenly' }}>
              <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>

                <div style={{ paddingTop: 10 }}>

                  <QRCode
                    size={180}
                    value={`${makeUri(`/forms/${record.key}`)}`}
                  />

                  <QRCode
                    id="powCloudQR"
                    size={800}
                    value={`${makeUri(`/forms/${record.key}`)}`}
                    style={{ display: 'none' }}
                  />
                </div>

                <Button style={{ marginTop: 10 }} type="primary" onClick={downloadQRCode}>
                  <DownloadOutlined />
                  Download
                </Button>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                    <TwitterShareButton
                      url={`${makeUri(`/forms/${record.key}`)}`}
                      title={'title'}
                      style={{ display: 'flex' }}
                      className="Demo__some-network__share-button"
                    >
                      <TwitterIcon bgStyle={{ 'fill': 'grey' }} size={32} round />
                    </TwitterShareButton>
                    <Text style={{ paddingLeft: 10 }}>Twitter</Text>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                    <FacebookShareButton
                      url={`${makeUri(`/forms/${record.key}`)}`}
                      quote={'title'}
                      className="Demo__some-network__share-button"
                      style={{ display: 'flex' }}
                    >
                      <FacebookIcon bgStyle={{ 'fill': 'grey' }} size={32} round />
                    </FacebookShareButton>
                    <Text style={{ paddingLeft: 10 }}>Facebook</Text>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                    <LinkedinShareButton
                      url={`${makeUri(`/forms/${record.key}`)}`}
                      className="Demo__some-network__share-button"
                      style={{ display: 'flex' }}
                    >
                      <LinkedinIcon bgStyle={{ 'fill': 'grey' }} size={32} round />
                    </LinkedinShareButton>
                    <Text style={{ paddingLeft: 10 }}>Linkedin</Text>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                    <RedditShareButton
                      url={`${makeUri(`/forms/${record.key}`)}`}
                      title={'title'}
                      windowWidth={660}
                      windowHeight={460}
                      style={{ display: 'flex' }}
                      className="Demo__some-network__share-button"
                    >
                      <RedditIcon bgStyle={{ 'fill': 'grey' }} size={32} round />
                    </RedditShareButton>
                    <Text style={{ paddingLeft: 10 }}>Reddit</Text>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
            {/* <Text strong>Embed Link To Your Form Page</Text>
            <Paragraph>

              <CodeBlock copiable>
                {`\
<a href="${makeUri(`/forms/${record.key}`)}" target="_blank">
  Fill out "${record.name}"
</a>`}
              </CodeBlock>
            </Paragraph> */}
            {/* <Paragraph>You can easily link to your form within an email message as well.</Paragraph>
            <Paragraph>
              Just add a hyperlink to your form URL:{' '}
              <Copiable inline>
                <Link href={makeUri(`/forms/${record.key}`)} target="_blank">
                  View Form
                </Link>
              </Copiable>
            </Paragraph> */}
          </>
        ),
      },
      {
        name: 'Embed (HTML)',
        content: (
          <>
            {/* <Paragraph>Use the following steps to embed your form in a static-HTML site:</Paragraph>
            <ol>
              <li>
                <Paragraph>
                  Add the following script directly before the closing <code>{'</body>'}</code> tag on the page you want
                  to display the form.
                  <br />
                  <CodeBlock copiable>{`\
<script type="module" src="${makeUri('formtopia/js/latest/formtopia-webcomponent.mjs')}"></script>\
`}</CodeBlock>
                </Paragraph>
              </li>
              <li> */}
            <Text strong>Embed Your Form Page</Text>
            <br />
            <br />
            <Paragraph>
              Place the Formtopia component in your markup where you want the form to be displayed. You can
              optionally override your form schema inside this tag:
              <br />
              <CodeBlock copiable>
                {`\
<script type="module" src="${makeUri('formtopia/js/latest/formtopia-webcomponent.mjs')}"></script>

<formtopia-form key="${record.key}">
<!--
${record.source}
-->
</formtopia-form>\
`}
              </CodeBlock>
            </Paragraph>
            {/* </li>
            </ol> */}
          </>
        ),
      },
      //       {
      //         name: 'Hugo CMS',
      //         links: [<Link href={makeUri('/formtopia/docs')}>Formtopia Documentation</Link>],
      //         content: (
      //           <>
      //             <Paragraph>You can easily embed your form into a Hugo site with the following steps:</Paragraph>
      //             <ol>
      //               <li>
      //                 <Paragraph>
      //                   Install the{' '}
      //                   <Link href={makeUri(`formtopia/docs/hugo`)} target="_blank">
      //                     Formtopia Plugin for Hugo
      //                   </Link>
      //                 </Paragraph>
      //               </li>
      //               <li>
      //                 <Paragraph>
      //                   Add the shortcode to any page you want to display the form:
      //                   <br />
      //                   <CodeBlock copiable inline>{`{{< formtopia/form key="${record.key}" >}}`}</CodeBlock>
      //                 </Paragraph>
      //               </li>
      //             </ol>
      //             <br />
      //             <Paragraph>
      //               If you want to manually override the form schema / fields (e.g. for requesting specific data which is not
      //               configured in the PowCloud dashboard), you can write{' '}
      //               <a href={makeUri('/formtopia/docs/formml')}>FormML</a> inline, like so:
      //             </Paragraph>
      //             <Paragraph>
      //               <CodeBlock>{`\
      // {{< formtopia/form key="${record.key}" >}}
      //   <!--
      //   \n${record.source}\n
      //   -->
      // {{</ formtopia/form >}}
      // `}</CodeBlock>
      //             </Paragraph>
      //           </>
      //         ),
      //       },
      // {
      //   name: 'Bridgetown CMS',
      //   content: (
      //     <>
      //       <strong>TODO</strong>
      //     </>
      //   ),
      // },
    ],
    [record]
  )

export const FormIntegrations: FC = () => {
  const record = useRecordContext()
  if (!record) return null

  const content = useTabContent(record as Form)
  const [activeTab, setActiveTab] = useState<string>('0')

  return (
    <Tabs
      tabPosition="left"
      activeKey={activeTab}
      onChange={(newTab) => {
        setActiveTab(newTab)
      }}
      style={{
        minHeight: 350,
        paddingTop: 10,
        paddingBottom: 10,
      }}
    >
      {content.map((pane, i) => (
        <TabPane tab={pane.name} key={i}>
          <Row gutter={20}>
            <Col span={24} md={24} xl={18}>
              {pane.content}
            </Col>
            <Col span={24} md={24} xl={6}>
              {/* <h3>Resources</h3>
              {pane.links?.map((link) => link)} */}
            </Col>
          </Row>
        </TabPane>
      ))}
    </Tabs>
  )
}
